<template>
  <div class="h-100">
    <main role="main" class="h-100">
        <common-master-table
          primary-key="deviceSerialId"
          table-no="mstDevice"
          table-api="master/device"
          ref="commonMasterTable"
          :editable="editableMixin.device.upd"
          :addable="editableMixin.device.ins"
          :mapping-no="`ie-device`"
          socket-entity="DEVICE_SOCKET"
        >
          <template v-slot:embedDeviceRegistrationMgmt>
            <embedded
              :iframeStyle="iframeStyle"
              :iframeSrc="iframeSrc"
            />
          </template>
        </common-master-table>
    </main>
  </div>
</template>

<script>
import CommonMasterTable from '../custom-components/CommonMasterTable'
import AppConstants from '../../constants/app.constants'
import RouterUtils from '../../_helpers/router.util'
import { plusHubService } from '../../_services/plus-hub.service'
import Embedded from '../custom-components/Embedded.vue'
export default {
  components: {
    // コンポーネント分割化
    CommonMasterTable,
    Embedded
  },
  data() {
    return {
      removeKeys: [],
      iframeSrc: AppConstants.DEVICE_REGISTRATION_MGMT_EMBEDDED_URL,
      iframeStyle: {
        position: 'relative',
        width: '100%',
        height: '260px'
      },
      updateQueryStr: ''
    }
  },
  beforeRouteUpdate(to, from) {
    if (to.query && to.query.hasOwnProperty('limit') && Object.keys(to.query).length === 1) {
      RouterUtils.correctTableRowsLimitParam(to.query)
      this.$refs.commonMasterTable.initData()
    }
  },
  mounted() {
    window.addEventListener('message', this.reloadDeviceList)
  },
  beforeDestroy () {
    window.removeEventListener('message', this.reloadDeviceList)
  },
  methods: {
    reloadDeviceList(_event) {
      if (!_event || !_event.data) {
        return
      }

      const type = _event.data.type
      const message = _event.data.message
      if (message && type === AppConstants.MST_DEVICE_POST_MESSAGE) {
        this.$refs.commonMasterTable.tackleAddNewData(message)
          .then(async result => {
            const externalDeviceId = message.externalDeviceId
            if (!result && externalDeviceId) {
              await plusHubService.deleteDevice(externalDeviceId)
            }
            // デバイスデータリストをリロードする
            this.$refs.commonMasterTable.fetchDataForNewSocketMsg()
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.btn_blue_round {
  width: 155px;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/mst-tables/DeviceMaster.vue